import md5 from 'md5';

export function getHashBasedNumber(text: string, bound: number) {
  const hash = md5(text);
  return (
    Math.round((parseInt(hash.substring(0, 7), 16) / 0xfffffff) * bound) % bound
  );
}
